var Routes;
(function (Routes) {
    Routes.home = "/";
    Routes.finishProfile = "/finish-profile";
    Routes.privacy = "/privacy";
    Routes.policyStatement = "/policy-statement";
    Routes.termsOfService = "/terms-of-service";
    Routes.workHome = "/focus-zone";
    Routes.threadPage = "/conversations/thread";
    Routes.conversationsPrefix = "/conversations";
    Routes.conversationsInbox = "/conversations/inbox";
    Routes.conversationsReminders = "/conversations/reminders";
    Routes.conversationsDone = "/conversations/done";
    Routes.conversationsDrafts = "/conversations/drafts";
    Routes.conversationsSent = "/conversations/sent";
    Routes.conversationsAllMail = "/conversations/all-mail";
    Routes.conversationsJunk = "/conversations/junk";
    Routes.conversationsDeleted = "/conversations/deleted";
    Routes.conversationsTextInbox = "/conversations/text-inbox";
    Routes.conversationsCallInbox = "/conversations/call-inbox";
    Routes.conversationsFolderMigration = "/settings/folder-migration";
    Routes.textThread = ({ textThreadId, messageForeignId, highlights, }) => ({
        pathname: `/conversations/text/${encodeURIComponent(textThreadId)}`,
        query: {
            ...(messageForeignId ? { messageId: messageForeignId } : {}),
            ...(highlights ? { highlights } : {}),
        },
    });
    Routes.emailThread = ({ foreignId, messageForeignId, highlights, }) => ({
        pathname: `/conversations/thread/${encodeURIComponent(foreignId)}`,
        query: {
            ...(messageForeignId ? { messageId: messageForeignId } : {}),
            ...(highlights ? { highlights } : {}),
        },
    });
    Routes.OwnerPortalView = "owner_portal";
    Routes.logRoute = ({ id, view, }) => ({
        pathname: `/log`,
        query: {
            logId: id,
            view,
        },
    });
    Routes.logRouteStr = ({ id, view, rowId, }) => `/log?logId=${id}${view ? "&view=" + view : ""}${rowId ? "&rowId=" + rowId : ""}`;
    Routes.dashboardStr = ({ id }) => `/dashboards?dashboardId=${id}
      `;
    Routes.createlogRoute = ({ projectId, }) => ({
        pathname: `/log`,
        query: {
            projectId: projectId,
        },
    });
    Routes.log = "/log";
    Routes.templateCenterBase = "/template-center";
    Routes.templateCenter = (id) => `${Routes.templateCenterBase}?templateId=` + id;
    Routes.contactsCompanies = "/contacts/companies";
    Routes.contactsGroups = "/contacts/groups";
    Routes.settingsContacts = "/settings/contacts";
    Routes.settingsProfile = "/settings/profile";
    Routes.settingsPhone = "/settings/phone";
    Routes.settingsTags = "/settings/tags";
    Routes.settingsProjects = "/settings/projects";
    Routes.settingsSignature = "/settings/signature";
    Routes.settingsInbox = "/settings/inbox";
    Routes.settingsNotifications = "/settings/notifications";
    Routes.settingsIntegrations = "/settings/integrations";
    Routes.settingsAutomation = "/settings/automation";
    Routes.settingsEmailTemplates = "/settings/email-templates";
    Routes.adminSettingsMasquerade = "/settings/admin/masquerade";
    Routes.adminSettingsTypesensePurge = "/settings/admin/typesense-purge";
    Routes.adminSettingsTableTemplates = "/settings/admin/table-templates";
    Routes.adminSettingsDashboards = "/settings/admin/dashboards";
    Routes.adminWhitelabelSettings = "/settings/admin/company-whitelabel";
    Routes.adminSettingsAutomationDigests = "/settings/admin/automation-digests";
    Routes.adminSettingsAutomationDigest = (digestId) => `/settings/admin/automation-digests/${digestId}`;
    Routes.adminSettingsDashboard = (dashboardId) => `/settings/admin/dashboards/${dashboardId}`;
    Routes.documents = "/documents";
    Routes.calendar = "/calendar";
    Routes.dashboards = "/dashboards";
    Routes.uploadAttachment = "/api/upload-attachment";
    Routes.uploadTableFile = "/api/upload-table-file";
    Routes.uploadTableTemplateFile = "/api/upload-template-file";
    Routes.uploadTableImportCSV = "/api/upload-table-import-csv";
    Routes.deleteTableFile = "/api/delete-table-file";
    Routes.uploadLogFile = "/api/upload-log-file";
    Routes.deleteLogFile = "/api/delete-log-file";
    Routes.uploadTaskFile = "/api/upload-task-file";
    Routes.uploadTemplateAttachmentFiles = "/api/upload-template-attachments";
    Routes.uploadAvatarFile = "/api/upload-user-avatar";
    Routes.uploadCompanyLogoFile = "/api/upload-company-logo";
    Routes.getCompanyLogoFile = "/api/get-company-logo";
    Routes.deleteTaskFile = "/api/delete-task-file";
    Routes.uploadSignatureImage = "/api/upload-signature-inline-images";
    Routes.uploadEmailTemplateImage = "/api/upload-email-template-inline-images";
    Routes.rAIFollowUp = "/api/roger-ai/follow-up";
    Routes.attachment = ({ id, newTab }) => `/api/attachment/${id}/${newTab ? "?showNewTab=1" : ""}`;
    Routes.rogerAttachment = ({ id }) => `/api/attachment/get-roger-attachment?attachmentId=${id}`;
    Routes.rogerAttachmentZip = ({ tableId, fileColumnIds, tagColumnId, }) => `/api/attachment/get-roger-attachments-zip?tableId=${tableId}&fileColumnIds=${JSON.stringify(fileColumnIds)}${tagColumnId ? "&tagColumnId=" + tagColumnId : ""}`;
    Routes.emailTemplateAttachment = ({ id }) => `/api/attachment/get-template-attachment?attachmentId=${id}`;
    Routes.attachmentThumbnail = ({ messageId, name, }) => `/api/thumbnail/${messageId}/${encodeURIComponent(name)}`;
    Routes.searchEverything = "/search";
    Routes.searchMessages = "/search/messages";
    Routes.searchDocuments = "/search/documents";
    Routes.searchContacts = "/search/contacts";
    Routes.searchStickies = "/search/stickies";
    const searchPathname = (kind) => {
        switch (kind) {
            case "messages":
                return Routes.searchMessages;
            case "documents":
                return Routes.searchDocuments;
            case "contacts":
                return Routes.searchContacts;
            case "stickies":
                return Routes.searchStickies;
            case undefined:
                return Routes.searchEverything;
        }
    };
    Routes.search = ({ kind, query, tag, contact, back }) => ({
        pathname: searchPathname(kind),
        query: { q: query, tag, contact, back },
    });
    Routes.stickiesBase = "/stickies";
    Routes.stickiesToDo = "/stickies/to-do";
    Routes.stickiesDone = "/stickies/done";
    Routes.stickiesDeleted = "/stickies/deleted";
    Routes.stickiesBoardsHome = "/stickies/boards/home";
    Routes.stickiesBoard = (id) => `/stickies/boards/${id}`;
    Routes.taskBoards = "/tasks/board";
    Routes.myTasks = "/tasks/board?boardId=my-tasks";
    Routes.taskBoard = (id) => Routes.taskBoards + "?boardId=" + id;
    Routes.workhub = "/home";
    Routes.workspace = (id) => `/workhub/${id}`;
    Routes.controlCenter = "/control-center";
    Routes.templateBuilderPage = (id, isArchived, view = "template") => `${Routes.controlCenter}/template-builder/${id}?view=${view}${isArchived ? "&archived=true" : ""}`;
    Routes.templateBuilderHome = (isArchived) => `${Routes.controlCenter}/template-builder${isArchived ? "?archived=true" : ""}`;
    Routes.templateBuilderHomeWithCompanyId = (companyId) => `${Routes.controlCenter}/template-builder?companyId=${companyId}`;
    Routes.superAdmin = `${Routes.controlCenter}/admin/`;
    Routes.automatedDigestsHome = `${Routes.controlCenter}/automated-digests`;
    Routes.automatedDigestsPage = (id) => `${Routes.automatedDigestsHome}/${id}`;
})(Routes || (Routes = {}));
export default Routes;
//# sourceMappingURL=routes.js.map